import { render } from "./Countdown.vue?vue&type=template&id=832908e6"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__